export function ArcReactor({ compact = false }: { compact?: boolean }) {
  return (
    <div className={`reactor ${compact ? 'reactor-compact' : ''}`} aria-hidden="true">
      <div className="reactor-halo" />
      <div className="reactor-ring reactor-ring-a"><i/><i/><i/><i/><i/><i/><i/><i/><i/><i/><i/><i/></div>
      <div className="reactor-ring reactor-ring-b" />
      <div className="reactor-ring reactor-ring-c"><span/><span/><span/><span/><span/><span/></div>
      <div className="reactor-core"><b>42</b><small>GW</small></div>
      <div className="reactor-scan" />
    </div>
  );
}
